import { LockedRegionView } from "@softmax/product-ux/editor";
import type { ReactNode } from "react";

import { useEditModeMaybe } from "../use-edit-mode-maybe";

export function LockedRegion({
  label,
  children,
  as,
}: {
  label?: string;
  children: ReactNode;
  as?: "div" | "span";
}) {
  const mode = useEditModeMaybe();
  return (
    <LockedRegionView editing={mode?.editing ?? false} label={label} as={as}>
      {children}
    </LockedRegionView>
  );
}
